import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

const getAuthHeaders = () => {
  const token = localStorage.getItem("clerkToken");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const fetchMakes = () =>
  axios.get(`${BASE_URL}/search/makes`, {
    headers: getAuthHeaders(),
  });

export const fetchModels = (make) =>
  axios.get(`${BASE_URL}/search/models`, {
    params: { make },
    headers: getAuthHeaders(),
  });

export const fetchTrims = (make, model, year) =>
  axios.get(`${BASE_URL}/search/trims`, {
    params: { make, model, year },
    headers: getAuthHeaders(),
  });

export const fetchYears = (make, model) =>
  axios.get(`${BASE_URL}/search/years`, {
    params: { make, model, year: "" },
    headers: getAuthHeaders(),
  });

export const fetchSearchDetails = (params) =>
  axios.get(`${BASE_URL}/search/details`, {
    params,
    headers: getAuthHeaders(),
  });

export const fetchVehicleInsights = (params) =>
  axios.get(`${BASE_URL}/dashboard/vehicle-insights`, {
    params,
    headers: getAuthHeaders(),
  });

export const fetchAIInsights = (summary, insights) =>
  axios.post(
    `${BASE_URL}/search/recommendations`,
    { summary, insights },
    { headers: getAuthHeaders() }
  );

export const fetchVehicleAnalysis = (params) =>
  axios.post(`${BASE_URL}/search/vehicle-analysis`, {
    make: params.make,
    mileage: params.mileage,
    model: params.model,
    radius: params.radius || 100,
    trim: params.trim,
    version: params.version,
    vin: params.vin,
    year: params.year,
  }, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
  });

export const fetchVehicleHistoryUsage = (vin = null) => {
  const params = {};
  if (vin) {
    params.vin = vin;
  }
  return axios.get(`${BASE_URL}/search/vehicle-history-usage`, {
    params,
    headers: getAuthHeaders(),
  });
};

export const generateVehicleHistoryReport = (vin) =>
  axios.post(`${BASE_URL}/search/vehicle-history-report`, {
    vin: vin,
  }, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
  });

export const fetchVehicleVersions = (vin) =>
  axios.get(`${BASE_URL}/search/vehicle-versions`, {
    params: { vin },
    headers: getAuthHeaders(),
  });
